import React, { useState } from "react";
import SalonAnalytics from "../../../components/admin/overview/SalonAnalytics";
import TopPerformingSalons from "../../../components/admin/overview/TopPerformingSalons";
import ActiveSalons from "../../../components/admin/overview/ActiveSalons";
import SalonsStats from "../../../components/admin/overview/SalonsStats";
import { MdAttachMoney, MdBarChart } from "react-icons/md";
import { IoMdCheckboxOutline } from "react-icons/io";
import { PiFolderSimpleUserFill } from "react-icons/pi";
import HeaderBox from "../../../components/admin/common/HeaderBox";
import { useQuery } from "@tanstack/react-query";
import { adminGetOverViewDetails } from "../../../network/admin";
import { Spin } from "antd";
type Props = {};

const SuperAdminOverview = (props: Props) => {
  const { data, isLoading } = useQuery(
    ["admin-overview"],
    () => adminGetOverViewDetails(),
    {
      select: (res) => res.data,
    }
  );
  return data && !isLoading ? (
    <div>
      <div className="flex items-center justify-between w-full gap-3 mb-8">
        <HeaderBox
          title="Salons signed up"
          value={data?.salons_count}
          icon={
            <MdBarChart className="w-8 h-8 flex items-center justify-center text-color-primary" />
          }
        />
        <HeaderBox
          title="Appointments booked"
          value={data?.appointments_count}
          icon={
            <IoMdCheckboxOutline className="w-8 h-8 flex items-center justify-center text-color-primary" />
          }
        />
        <HeaderBox
          title="New leads"
          value={data?.new_leads}
          icon={
            <PiFolderSimpleUserFill className="w-8 h-8 flex items-center justify-center text-color-primary" />
          }
        />
        <HeaderBox
          title="Revenue"
          value={data?.revenue + " SAR"}
          icon={
            <MdAttachMoney className="w-8 h-8 flex items-center justify-center text-color-primary" />
          }
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <SalonAnalytics />
        <SalonsStats />
      </div>
    </div>
  ) : (
    <div className="flex h-screen items-center justify-center">
      <Spin size="large" />
    </div>
  );
};

export default SuperAdminOverview;
